import React from 'react';

import styles from './styles.module.scss';
import { useCallAudioPlayer } from './hooks';
import Transcript from './components/transcript';
import Controls from './components/controls';
import Waveform from './components/waveform';
import Time from './components/time';

import type { TranscriptItem } from 'infrastructure/hooks/calls/use-get-call-transcribe/types';

interface Props {
  audioUrl: string;
  callId: string;
  transcripts?: TranscriptItem[] | null;
  transcriptsLoading: boolean;
  showTranscript: boolean;
  toggleShowTranscript: () => void;
  callTranscribeErrorMessage?: string;
}

const CallAudioPlayer: React.FC<Props> = ({
  audioUrl,
  callId,
  transcripts,
  transcriptsLoading,
  showTranscript,
  toggleShowTranscript,
  callTranscribeErrorMessage,
}) => {
  const {
    waveformRef,
    isPlaying,
    volume,
    isMuted,
    currentTimeSeconds,
    durationSeconds,
    isLoading,
    togglePlayPause,
    stop,
    rewind,
    forward,
    toggleMute,
    handleVolumeChange,
    setCurrentTimeSeconds,
  } = useCallAudioPlayer(audioUrl);

  return (
    <div>
      <div className={styles['player-container']}>
        <Waveform isLoading={isLoading} waveformRef={waveformRef} />
        <Time
          callId={callId}
          currentTimeSeconds={currentTimeSeconds}
          durationSeconds={durationSeconds}
        />
        <Controls
          isLoading={isLoading}
          rewind={rewind}
          togglePlayPause={togglePlayPause}
          forward={forward}
          stop={stop}
          isPlaying={isPlaying}
          volume={volume}
          toggleMute={toggleMute}
          isMuted={isMuted}
          handleVolumeChange={handleVolumeChange}
          toggleShowTranscript={toggleShowTranscript}
          showTranscript={showTranscript}
        />
      </div>
      {showTranscript && (
        <Transcript
          transcripts={transcripts}
          transcriptsLoading={transcriptsLoading}
          callTranscribeErrorMessage={callTranscribeErrorMessage}
          currentTimeSeconds={currentTimeSeconds}
          setCurrentTimeSeconds={setCurrentTimeSeconds}
        />
      )}
    </div>
  );
};

export default CallAudioPlayer;
